import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Doctor' },
    { value: 2, label: 'Health Specialist' },
    { value: 3, label: 'Nurse' },
    { value: 4, label: 'Other' },
  ],
});
